import React, { useState, useEffect } from 'react';

const PaymentCompleted = (props) => {
    return (
        <React.Fragment>
            <div className="card mt-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h4 className='text-primary'>¡Pago exitoso! 🎉 Tu transacción se ha completado correctamente. Gracias por tu compra. 📩 Revisa tu correo para más detalles.</h4>
                        </div>

                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-12 text-center">
                            <a
                                className='btn btn-primary text-white'
                                href='/'
                            >
                                Ir a mis cursos
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}


export default PaymentCompleted;
